module.exports = __webpack_public_path__ + "static/media/Pathetic.42c93c7c.jpg";